import { render, staticRenderFns } from "./IconCancel.vue?vue&type=template&id=7c4a833a&"
import script from "./IconCancel.vue?vue&type=script&lang=ts&"
export * from "./IconCancel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports